import { render } from "./FilterButton.vue?vue&type=template&id=454c504b&scoped=true"
import script from "./FilterButton.vue?vue&type=script&lang=js"
export * from "./FilterButton.vue?vue&type=script&lang=js"

import "./FilterButton.vue?vue&type=style&index=0&id=454c504b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454c504b"]])

export default __exports__